import { Button } from './ui/button';
import { RELEASES } from '../config/releases';
import { trackDownload } from '../lib/analytics';

interface DownloadButtonProps {
  className?: string;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  showVersion?: boolean;
}

export function DownloadButton({
  className,
  variant = 'default',
  size = 'default',
  showVersion = true
}: DownloadButtonProps) {
  const buttonText = showVersion
    ? `Download v${RELEASES.latest.version}`
    : 'Download';

  const handleClick = () => {
    trackDownload(RELEASES.latest.version, RELEASES.latest.downloadUrl);
  };

  return (
    <Button
      asChild
      variant={variant}
      size={size}
      className={className}
    >
      <a
        href={RELEASES.latest.downloadUrl}
        download
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        {buttonText}
      </a>
    </Button>
  );
}
